export function formatINR(n) {
  const v = Number(n || 0);
  return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function formatDate(input) {
  if (!input) return "-";
  const d = new Date(input);
  if (isNaN(d)) {
    // handle YYYY-MM-DD
    const parts = String(input).split("-");
    if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
    return input;
  }
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export const sanitizeMobile = (v) => String(v || "").replace(/\D/g, "").slice(0, 10);
export const isValidMobile = (v) => /^\d{10}$/.test(String(v || ""));
